import React from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { FiHash } from "react-icons/fi";

import styles from "./SupplierPartyView.module.css";
import { handleNumInputChange } from "../../MIS/Global";

const SupplierPartyView = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  setFieldTouched,
}) => {
  return (
    <form autoComplete="off">
      <Card className={styles.mainCard}>
        <Card.Body className={styles.cardBody}>

          <Row className="g-3">
            <Col md={12}>
            <div className={styles.spaceBetween}>
              <div>
              <Form.Label className={styles.label}>Type</Form.Label>
                <Form.Select
                  name="is_type"
                  value={values.is_type}
                  onChange={handleChange}
                  className={styles.formControl}
                >
                  <option value="supplier">Supplier</option>
                  <option value="party">Party</option>
                  <option value="both">Both</option>
              </Form.Select>
              </div>
              <div>
              <Form.Label className={styles.label}>Status</Form.Label>
                  <div className={styles.switchBox}>
                    <Form.Check
                      type="switch"
                      name="is_active"
                      checked={values.is_active}
                      onChange={(e) =>
                        setFieldValue("is_active", e.target.checked)
                      }
                      label={values.is_active ? "Active" : "Inactive"}
                    />
                  </div>
              </div>
            </div>
            
            </Col>
            {/* NAME */}
            <Col md={3}>
              <Form.Label className={styles.label}>Name</Form.Label>
              <Form.Control
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={() => setFieldTouched("name")}
                isInvalid={touched.name && errors.name}
                placeholder="Supplier/Party name"
                className={styles.formControl}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Col>

            {/* MOBILE */}
            <Col md={3}>
              <Form.Label className={styles.label}>Mobile</Form.Label>
              <Form.Control
                name="mobile"
                value={values.mobile}
                onChange={handleChange}
                onBlur={() => setFieldTouched("mobile")}
                isInvalid={touched.mobile && errors.mobile}
                placeholder="Mobile"
                className={styles.formControl}
                maxLength={10}
                onKeyDown={handleNumInputChange}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobile}
              </Form.Control.Feedback>
            </Col>

            {/* WHATSAPP */}
            <Col md={3}>
              <Form.Label className={styles.label}>WhatsApp</Form.Label>
              <Form.Control
                name="whatsapp"
                value={values.whatsapp}
                onChange={handleChange}
                className={styles.formControl}
                placeholder="WhatsApp"
                maxLength={10}
                onKeyDown={handleNumInputChange}
              />
            </Col>

            {/* EMAIL */}
            <Col md={3}>
              <Form.Label className={styles.label}>Email</Form.Label>
              <Form.Control
                name="email_id"
                value={values.email_id}
                onChange={handleChange}
                onBlur={() => setFieldTouched("email_id")}
                isInvalid={touched.email_id && errors.email_id}
                placeholder="Email"
                className={styles.formControl}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email_id}
              </Form.Control.Feedback>
            </Col>

            {/* GST */}
            <Col md={3}>
              <Form.Label className={styles.label}>GST</Form.Label>
              <div className={styles.inputWrapper}>
                <FiHash className={styles.inputIcon} />
                <Form.Control
                  name="gst_number"
                  value={values.gst_number}
                  onChange={(e) =>
                    setFieldValue("gst_number", e.target.value.toUpperCase())
                  }
                  placeholder="GST No"
                  className={styles.formControl}
                  maxLength={15}
                />
              </div>
            </Col>

            {/* OPENING */}
            <Col md={3}>
              <Form.Label className={styles.label}>Opening ₹</Form.Label>
              <Form.Control
                type="number"
                name="opening"
                value={values.opening}
                onChange={handleChange}
                className={styles.formControl}
                placeholder="0.00"
                // onKeyDown={handleNumInputChange}
              />
            </Col>

            {/* CITY */}
            <Col md={2}>
              <Form.Label className={styles.label}>City</Form.Label>
              <Form.Control
                name="city"
                value={values.city}
                onChange={handleChange}
                className={styles.formControl}
              />
            </Col>

            {/* STATE */}
            <Col md={2}>
              <Form.Label className={styles.label}>State</Form.Label>
              <Form.Control
                name="state"
                value={values.state}
                onChange={handleChange}
                className={styles.formControl}
              />
            </Col>

            {/* PIN */}
            <Col md={2}>
              <Form.Label className={styles.label}>Pin</Form.Label>
              <Form.Control
                name="pin"
                value={values.pin}
                onChange={handleChange}
                className={styles.formControl}
                onKeyDown={handleNumInputChange}
              />
            </Col>

            

            {/* ADDRESS */}
            <Col md={9}>
              <Form.Label className={styles.label}>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="address"
                value={values.address}
                onChange={handleChange}
                className={styles.formControl}
                placeholder="Address"
              />
            </Col>

          </Row>

        </Card.Body>
      </Card>
    </form>
  );
};

export default SupplierPartyView;